export interface MobileTutorialStep {
  id: number;
  targetElementId?: string; // data-tutorial-id to scroll to (undefined for no scroll)
  title: string;
  description: string;
  isFirst?: boolean;
  isLast?: boolean;
}

export const MOBILE_TUTORIAL_STEPS: MobileTutorialStep[] = [
  {
    id: 1,
    title: "Welcome to Wallstreetle!",
    description: "Identify the mystery stock using price charts, financial metrics, and hints. You have 4 attempts to guess correctly. Let's take a quick tour!",
    isFirst: true,
  },
  {
    id: 2,
    targetElementId: "price-chart",
    title: "Price Chart",
    description: "Study the historical price movements to identify patterns and trends that might help you recognize the company.",
  },
  {
    id: 3,
    targetElementId: "financial-metrics",
    title: "Financial Metrics",
    description: "Review key financial data like market cap, P/E ratio, and volume to narrow down your options.",
  },
  {
    id: 4,
    targetElementId: "hints-section",
    title: "Hints",
    description: "Each incorrect guess reveals a new hint about the company. Use them wisely to guide your next attempt!",
  },
  {
    id: 5,
    targetElementId: "submit-guesses",
    title: "Make a Guess",
    description: "Select a company from the dropdown and submit your guess. You have 4 attempts to identify the correct stock!",
  },
  {
    id: 6,
    title: "You're All Set!",
    description: "After completing a game, you can share your results and compete on the leaderboard. Tap anywhere to start playing!",
    isLast: true,
  },
];

export const TOTAL_MOBILE_TUTORIAL_STEPS = MOBILE_TUTORIAL_STEPS.length;
